<template>
  <div class="byyw">
    <div class="banner">
      <div class="img">
        <img :src="this.$store.getters.banner[this.$route.path]" />
      </div>
    </div>
    <div class="content">
      <div class="contentDiv" style="background:#f5f5f5;line-height:1rem;">
        <div class="contentBox" v-html="content"></div>
        <!-- <div class="contentBox">
          <div class="bannerContent">
            <div class="bBox">
              <div class="bBox1 ac">
                <div class="bBoxList">
                  <img src="../../assets/byyw1.png" alt="" class="item-img" />
                  <p class="title1">
                    实力雄厚
                  </p>
                  <p class="ms">
                    上市公司
                  </p>
                  <p class="ms">
                    值得托付
                  </p>
                </div>
                <div class="bBoxList">
                  <img src="../../assets/byyw2.png" alt="" class="item-img" />
                  <p class="title1">
                    产品多样
                  </p>
                  <p class="ms">
                    多种产品套餐供您选择
                  </p>
                </div>
                <div class="bBoxList">
                  <img src="../../assets/byyw3.png" alt="" class="item-img" />
                  <p class="title1">
                    消费透明
                  </p>
                  <p class="ms">
                    标准化
                  </p>
                  <p class="ms">
                    公开报价
                  </p>
                </div>
                <div class="bBoxList">
                  <img src="../../assets/byyw4.png" alt="" class="item-img" />
                  <p class="title1">
                    全程陪同
                  </p>
                  <p class="ms">
                    专业顾问协助处理相关事宜
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="conBox">
            <div class="conItem conItemText">
              <p class="txtTitle marginb20" style="text-align: left;">
                白事天使简介
              </p>
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="require('../../assets/tianshi.png')"
              />
              <p class="conItemTextd" style="text-align: left;">
                天使理念：尊重逝者，安慰生者！ 让告别变得美丽，让生命得以延续……
              </p>
              <p class="conItemTextd" style="text-align: left;">
                天使服务：专业·细腻·个性
              </p>
              <p class="conItemTextp" style="text-align: left;">
                东营嘉盛陵园有限责任公司，致力于殡仪服务的品质提升及殡葬礼仪的策划执行，是一家融合殡、葬的一站式专业殡葬服务机构。提供殡仪服务、追思告别及安葬仪式，获得社会和家属的认可和称赞。
                公司各类专业技术人员达到30余人，以丰富、细腻的情感及现代与传统相结合的方式展现白事天使的魅力。
              </p>
              <p class="conItemTextp" style="text-align: left;">
                团队全体成员全年无休，24小时随时为您及您的家人提供我们最真诚的服务。
              </p>
            </div>
            <div class="conItem conItema">
              <p class="txtTitle marginb20" style="text-align: left;">
                白事服务内容
              </p>
              <p class="conItemad" style="text-align: left;">
                殡葬活动过程中各种事情的“解决方案” 白事天使团队全程陪同服务指导
              </p>
              <div class="conItemas">
                <div class="conItemas1 ab">
                  <div class="conItemasList">
                    <p class="title">
                      病
                    </p>
                    <p class="itemp">
                      临终关怀
                    </p>
                    <p class="itemp">
                      生前契约
                    </p>
                  </div>
                  <div class="conItemasList">
                    <p class="title">
                      询
                    </p>
                    <p class="itemp">
                      殡葬相关
                    </p>
                    <p class="itemp">
                      解决方案
                    </p>
                  </div>
                  <div class="conItemasList">
                    <p class="title">
                      丧
                    </p>
                    <p class="itemp">
                      遗体接运
                    </p>
                    <p class="itemp">
                      灵堂设立
                    </p>
                    <p class="itemp">
                      习俗指导
                    </p>
                  </div>
                  <div class="conItemasList">
                    <p class="title">
                      殡
                    </p>
                    <p class="itemp">
                      守灵出殡
                    </p>
                    <p class="itemp">
                      更衣化妆
                    </p>
                    <p class="itemp">
                      告别追悼
                    </p>
                    <p class="itemp">
                      大殓火化
                    </p>
                    <p class="itemp">
                      产品提供
                    </p>
                  </div>
                  <div class="conItemasList">
                    <p class="title">
                      葬
                    </p>
                    <p class="itemp">
                      墓地参观
                    </p>
                    <p class="itemp">
                      骨灰寄存
                    </p>
                    <p class="itemp">
                      购墓指引
                    </p>
                    <p class="itemp">
                      设计制作
                    </p>
                    <p class="itemp">
                      落葬仪式
                    </p>
                  </div>
                  <div class="conItemasList">
                    <p class="title">
                      祭
                    </p>
                    <p class="itemp">
                      代客祭扫
                    </p>
                    <p class="itemp">
                      网络祭扫
                    </p>
                    <p class="itemp">
                      祭扫仪式
                    </p>
                  </div>
                </div>
              </div>
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="require('../../assets/tuandui.png')"
              />
            </div>

            <div class="conItem conItem-3">
              <p class="txtTitle marginb20" style="text-align: left;">
                白事服务流程
              </p>
              <div class="conItembslc">
                <div class="conItembslc1">
                  <div class="conItembslcList">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA2CAMAAACLF4vOAAAAAXNSR0IArs4c6QAAAUFQTFRFAAAA//8A/39/qqpV/6pVv39A/79A/79/zJlm1KpV1Kp//6p/27Zt359gxo5V46px0aJd6KJd6qpq2J1i2LFi26Rb26Rt3apm369g0qVp4aVp1Jxj46pj16Fr5KFr2aZm26ph3KJo3qZk359g359q36pq4KNm2J1i2Kdi4qds2aFo5KRk3Kdh3aFm3qVr5q1r36do4KJk4Kpk4aVp26hm4qhm3aVn3aFl2aZm36Zm4Khq4aRn4apn4aZl4aZr3KJj4qho3apm3qFk3qZp3qNn3qhn36Vl26do26Nm3KVk36dm26Rk36Rk26Zn4KZn3KNl4Kdl3KRo3qdp36Zl36No3KVm4KVm3KJk3adn3aVl3qZn3qRm3qhm26Vl36Vl36Vo36Zn3KRl4Khl3aVn4KVn3aNm4Kdm3aRl3aRo3aho3qZnULAnzQAAAGt0Uk5TAAECAwMEBAQFBgYGBwgJCQsLDA0NDg4PEBEREhITExQVFhcYGBgZGhoaGxwdHh8fICEhIiMjJSYoKCkqKisrLCwtLi4vLzAxMjM3ODg5OTo6Oz0/QEFBQkNERUZGR0dHSElJSkpLS0xMTE1HDWkfAAABoklEQVRIx43WaVsBURTA8UMjlBIlSfsiLbQordpTWqVUFCqFzvf/AIl7ptmYc185//k9nplrMDDjswJ7IVbS613tzVC0sSx1XF9fR842dv67gVBqYsTiXEsbq6EGI24ZU9uZLBQYd43s2AsaYozpqGO/hkpc+B8qQTXt3vlAVGEYPKvS9GxR0MBhGVGLAUbeaIySlPZyqFsNDN53MeYlgd2IrTCEaI4b4LIGwyW9tR6fr2hxgEJQg7/WIKLFkBEhocZXfWCA4yLklPgh9Pdaj31U/IR/biebh/QYSqJEmjiz4aYjBvhOfdKKZYAPRLnhYNrNVw6WP0QnAwcpeRjYo9679riX0igDOylNMXAnpQUGligtMbCDUoiBXZQmGFi+3YcZWL5HBxh4gpKbgRdFqVoZmL5XWc5ddyFKioMfRdlkYKkiyiwDT9P1uRj4RIQ0mOOOogirDLws5lqPOba/tj4LHaZNxnFzvE3jNZhhZ4qmmt8Eh08/5R/5JJhgxZ/Hk42PC15g45If2DjrAS6uJmzAxN/J/jYPMgqcvz8O25nPU78c/ZpLlX9bxAAAAABJRU5ErkJggg=="
                      alt=""
                      class="item-num fl"
                    />
                    <p class="title" style="text-align: left;">
                      咨询洽谈
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      亲人去世后我们关心的是您与亲人心灵上的创伤
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、我们将为您提供殡葬一条龙温馨服务及相关事宜代处理
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、提供24小时专线，全年无休服务：0546-75889977
                    </p>
                  </div>
                  <div class="conItembslcList">
                    <img src="../../assets/num2.png" alt="" class="item-num fl" />
                    <p class="title" style="text-align: left;">
                      方案确定
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      根据家属需求策划葬礼，留给亲友一份难忘的回忆
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、预定殡仪馆告别厅、预定火化时间，登记逝者信息
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、推荐殡仪馆、灵车、告别厅、火化炉、骨灰盒寿衣等供家属选择
                    </p>
                  </div>
                  <div class="conItembslcList">
                    <img src="../../assets/num3.png" alt="" class="item-num fl" />
                    <p class="title" style="text-align: left;">
                      灵车接运
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      无论在医院还是家中，无论白天还是夜里都能第一时间为您服务
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、预约殡仪馆灵车和工作人员接送遗体至殡仪馆或其他指定地点
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、协助家属办理遗体寄存手续等相关事宜
                    </p>
                  </div>
                  <div class="conItembslcList">
                    <img src="../../assets/num4.png" alt="" class="item-num fl" />
                    <p class="title" style="text-align: left;">
                      告别仪式
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      提前安排好告别厅，与亲人的最后一次挽别
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、提前做好遗体化妆，布置告别厅，包括鲜花、花圈、灯光、横幅等
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、配备专业司仪引导亲友告别，并按需进行超度送灵，留下珍贵记录
                    </p>
                  </div>
                  <div class="conItembslcList">
                    <img src="../../assets/num5.png" alt="" class="item-num fl" />
                    <p class="title" style="text-align: left;">
                      遗体火化
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      我们以感同身受的心情，协助您整理火化后的逝者骨灰
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、引导家属火化前行礼，送别亲人最后一程
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、引导家属至焚烧炉焚烧花圈、遗物等
                    </p>
                    <p class="itemp" style="text-align: left;">
                      3、工作人员封盖包装并由家属确认后认领
                    </p>
                  </div>
                  <div class="conItembslcList">
                    <img src="../../assets/num6.png" alt="" class="item-num fl" />
                    <p class="title" style="text-align:left;">
                      骨灰寄存
                    </p>
                    <p class="items"></p>
                    <p class="itemp" style="text-align: left;">
                      协助您将逝者骨灰安葬在预定之处供日后追思
                    </p>
                    <p class="itemp" style="text-align: left;">
                      1、根据实际要求，选择骨灰寄存、塔葬、树葬、草坪葬及墓地葬
                    </p>
                    <p class="itemp" style="text-align: left;">
                      2、为您全程指导选择墓地用品和随葬品，安葬吉日等
                    </p>
                    <p class="itemp" style="text-align: left;">
                      3、殡仪服务专员将全程免费接送指导选墓，安排骨灰安葬
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div class="fixed1 con-fixed as">
                <div class="tel">
                  <a href="tel:0546-75889977" style="color: #2c3e50;"
                    ><button>
                      <font _mstmutation="1"> 官方咨询热线 </font><span>0546-75889977</span>
                    </button></a
                  >
                </div>
                <div class="right">
                  <button><font _mstmutation="1"> 免费获取报价 </font><span>殡仪报价</span></button>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div> -->
        <!-- <div class="contentTxt">{{ content }}</div> -->
        <!-- <div>
          <div>
            <div style="position:fixed;bottom:1rem;">
              免费获取报价:
              <div class="tel">
                <a href="tel:0546-75889977" style="color: #2c3e50;"
                  ><button>
                    <span>0546-75889977</span>
                  </button></a
                >
                <a href="tel:0546-75889977" style="color: #2c3e50;"
                  ><button>
                    <span>客服</span>
                  </button></a
                >
              </div>
            </div>
            <div></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'binyiyewu',
  components: {},
  data() {
    return {
      content: '',
    }
  },
  created() {
    // this.getDate()
    var that = this
    this.$queryOne('OweArticle', { code: 'BYYW' }, ['content'], function(res) {
      that.content = res.data['content']
    })
  },
  methods: {
    // getDate() {
    //   let _data = {
    //     entity: 'OweArticle',
    //     fields: ['id', 'code', 'content'],
    //     code: 'BYYW',
    //   }
    //   let _this = this
    //   axios.post('/api/owearticle/queryOne', _data).then(res => {
    //     if (res.data.code == 1) {
    //       _this.content = res.data.data.content
    //     }
    //   })
    // },
  },
}
</script>

<style>
.byyw .base-bannerContent {
  height: 3.73rem;
}
.van-image {
  position: relative;
  display: inline-block;
}
.byyw .contentBox .bannerContent .bBox {
  padding: 0.67rem;
}
.byyw .ac {
  display: flex;
  justify-content: space-between;
}
.byyw .contentBox .bannerContent .bBoxList {
  width: 1.6rem;
  flex-shrink: 0;
}
.byyw .contentBox .bannerContent .bBoxList .item-img {
  width: 1.33rem;
  height: 1.33rem;
  margin: 0 auto 0.27rem;
}
.byyw .contentBox .bannerContent .bBoxList .title {
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
  line-height: 0.53rem;
  flex-shrink: 0;
  text-align: center;
}
.byyw .contentBox .bannerContent .bBoxList .ms {
  font-size: 0.27rem;
  color: #666;
  line-height: 0.37333rem;
  text-align: center;
}
.byyw .contentBox .bannerContent .bBoxList .ms {
  font-size: 0.27rem;
  color: #666;
  line-height: 0.37333rem;
  text-align: center;
}
.byyw .contentBox .conBox .conItemText {
  font-size: 0.37333rem;
  line-height: 0.53rem;
}
.byyw .contentBox .conBox .conItem {
  padding: 0.67rem 0.4rem;
}
.byyw .txtTitle {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
}
.byyw .marginb20 {
  margin-bottom: 0.53rem;
}
.byyw .contentBox .conBox .conItemText img {
  width: 9.2rem;
  height: 5.33333rem;
  margin-bottom: 0.53rem;
}
.byyw .contentBox .conBox .conItemTextd {
  color: #dea767;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItemTextd {
  color: #dea767;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItemTextp {
  color: #333;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItemTextp {
  color: #333;
  margin-bottom: 0.13333rem;
}

.byyw .contentBox .conBox .conItemad {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  margin-bottom: 0.4rem;
}
.byyw .ab {
  display: flex;
  flex-wrap: wrap;
}
.byyw .contentBox .conBox .conItemasList {
  width: 2.93rem;
  height: 6.93rem;
  background: hsla(0, 0%, 100%, 0.7);
  border-radius: 0.16rem;
  text-align: center;
  padding: 0.53rem;
  margin-right: 0.2rem;
  margin-bottom: 0.4rem;
}
.byyw .contentBox .conBox .conItemasList .title {
  font-size: 0.96rem;
  font-weight: 600;
  color: #dea767;
  line-height: 1.81rem;
  width: 1.87rem;
  height: 1.87rem;
  border: 0.027rem solid #dea767;
  border-radius: 50%;
  margin-bottom: 0.4rem;
}
.byyw .contentBox .conBox .conItemasList .itemp {
  font-size: 0.42667rem;
  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.18667rem;
}
.byyw .contentBox .conBox .conItemasList .itemp {
  font-size: 0.42667rem;
  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.18667rem;
}
.byyw .contentBox .conBox .conItem-3 {
  width: 100%;
  height: 38.34667rem;
}
.byyw .contentBox .conBox .conItem {
  padding: 0.67rem 0.4rem;
}
.byyw .contentBox .conBox .conItembslcList {
  width: 9.2rem;
  max-height: 6.4rem;
  background: hsla(0, 0%, 100%, 0.7);
  border-radius: 0.13333rem;
  margin-bottom: 0.67rem;
  padding: 0.4rem 0.32rem;
  position: relative;
}
.byyw .contentBox .conBox .conItembslcList:first-child .item-num {
  width: 0.58667rem;
}
.byyw .contentBox .conBox .conItembslcList .item-num {
  width: 0.8rem;
  height: 0.72rem;
  position: absolute;
  left: 0;
  top: 0.32rem;
}
.byyw .contentBox .conBox .conItembslcList .title {
  font-size: 0.42667rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.61333rem;
  text-align: right;
  margin-left: 0.5rem;
}
.byyw .contentBox .conBox .conItembslcList .items {
  width: 100%;
  height: 0.027rem;
  border-bottom: 0.027rem dotted #dea767;
  margin: 0.4rem 0 0.27rem;
}
.byyw .contentBox .conBox .conItembslcList .itemp {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItembslcList .itemp {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItembslcList .itemp:last-child {
  margin-bottom: 0;
}
.byyw .contentBox .conBox .conItembslcList .itemp {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  margin-bottom: 0.13333rem;
}
.byyw .contentBox .conBox .conItemasList:nth-child(3n) {
  margin-right: 0;
}
.byyw .content {
  /* padding: 0.67rem 0.4rem; */
  background: #fff;
}
.byyw .banner {
  height: 3.73rem;
}
.byyw .title1 {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
  margin-left: 0.2rem;
  /* margin-left: 0.5rem; */
  margin-bottom: 0.53rem;
}
.byyw .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.byyw .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.byyw .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap; */
  word-wrap: break-word;
}
.byyw .contentTxt p {
  margin: 0.5rem 0;
  color: #666;
  line-height: 0.7rem;
}
.tel {
  font-size: 0.5rem;
}
</style>
